<template>
  <div>
    <v-menu
      ref="periodPickerMenu"
      v-model="periodPickerMenu"
      :close-on-content-click="false"
      :return-value.sync="monthPickerValue"
      transition="scale-transition"
      offset-y
      max-width="300px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="periodPickerLabel"
          :label="labelValue"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          outlined
          hide-details
        ></v-text-field>
      </template>
      <v-card>
        <v-card-text class="mx-0 px-0">
          <v-row>
            <v-col cols="12">
              <v-date-picker
                v-model="monthPickerValueComputed"
                type="month"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-select
                class="px-5"
                :items="periodsList"
                v-model="selectedPeriodComputed"
                :label="labelValue"
                outlined
                hide-details
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" align="end" class="px-4">
              <v-btn
                text
                color="primary"
                @click="cancelButtonHandler"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="acceptButtonHandler"
              >
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { nextTick } from 'vue'
import { WEEKLY } from '@/lib/constants/payFrequencies'

export default {
  props: [
    'label',
    'date'
  ],
  data () {
    return {
      periodPickerLabel: null,
      monthPickerValue: null,
      monthPickerValueTemp: null,
      periodPickerMenu: false,
      selectedPeriod: null,
      selectedPeriodTemp: null,
      year: new Date().getFullYear(),
      WEEKLY
    }
  },
  watch: {
    async monthPickerValueTemp (newValue) {
      if (newValue) {
        let temp = newValue.split('-')
        this.year = temp[0]
        let month = temp[1]
        if (this.year && month) {
          let filters = { 'year': this.year, 'month': month, 'periodicity': this.WEEKLY }
          this.getPeriods(filters)
          this.selectedPeriodTemp = 0
        }
      }
    }
  },
  computed: {
    ...mapFields('periods', ['periodsList']),
    labelValue: {
      get () {
        return this.label ? this.label : 'Week'
      }
    },
    monthPickerValueComputed: {
      get () {
        if (this.monthPickerValueTemp !== null) {
          return this.monthPickerValueTemp
        }
        return this.monthPickerValue
      },
      set (newValue) {
        this.monthPickerValueTemp = newValue
      }
    },
    selectedPeriodComputed: {
      get () {
        if (this.selectedPeriodTemp !== null) {
          return this.selectedPeriodTemp
        }
        return this.selectedPeriod
      },
      set (newValue) {
        this.selectedPeriodTemp = newValue
      }
    },
    dateComputed: {
      get () {
        return this.date
      },
      set (newValue) {
        this.$emit('dateChange', newValue)
      }
    }
  },
  methods: {
    ...mapActions('periods', ['getPeriods']),
    ...mapActions('datetimeHelper', [
      'getStaffLynxTime'
    ]),
    async acceptButtonHandler () {
      this.$emit('weekChange', this.periodsList[this.selectedPeriodTemp].dateBegin, this.periodsList[this.selectedPeriodTemp].dateEnd)
      this.selectedPeriod = this.selectedPeriodTemp
      this.monthPickerValue = this.monthPickerValueTemp
      this.$refs.periodPickerMenu.save(this.monthPickerValue)
      this.periodPickerLabel = this.periodsList[this.selectedPeriodTemp].text
      this.selectedPeriodTemp = null
      this.monthPickerValueTemp = null
    },
    async cancelButtonHandler () {
      this.periodPickerMenu = false
      this.selectedPeriodTemp = null
      this.monthPickerValueTemp = null
      let temp = this.monthPickerValue.split('-')
      this.year = temp[0]
      let month = temp[1]
      if (this.year && month) {
        let filters = { 'year': this.year, 'month': month, 'periodicity': this.WEEKLY }
        await this.getPeriods(filters)
        await nextTick()
      }
    }
  },
  async created () {
    if (!this.dateComputed) {
      this.dateComputed = new Date(await this.getStaffLynxTime())
    }
    await nextTick()
    this.year = this.dateComputed.getFullYear()
    let month = this.dateComputed.getMonth() + 1
    this.monthPickerValue = this.year + '-' + (month < 10 ? '0' + month : month)
    let filters = { 'year': this.year, 'month': month, 'periodicity': this.WEEKLY }
    await this.getPeriods(filters)
    let selectedPeriod = this.periodsList.filter((period) => this.dateComputed >= new Date(period.dateBegin) && this.dateComputed <= new Date(period.dateEnd))[0]
    if (!selectedPeriod) {
      let nextMonthDate = new Date()
      nextMonthDate.setDate(1)
      nextMonthDate.setMonth(nextMonthDate.getMonth() + 1)
      this.year = nextMonthDate.getFullYear()
      month = nextMonthDate.getMonth() + 1
      filters = { 'year': this.year, 'month': month, 'periodicity': this.WEEKLY }
      await this.getPeriods(filters)
      selectedPeriod = this.periodsList.filter((period) => this.dateComputed >= new Date(period.dateBegin) && this.dateComputed <= new Date(period.dateEnd))[0]
      this.monthPickerValue = this.year + '-' + (month < 10 ? '0' + month : month)
    }
    this.$emit('weekChange', selectedPeriod.dateBegin, selectedPeriod.dateEnd)
    this.selectedPeriod = selectedPeriod.value
    this.periodPickerLabel = selectedPeriod.text
  }
}
</script>
